export const PREVIEW_CASE_WIDTHS = {
  leaderboardList:
    "tw-max-w-full sm:tw-max-w-[34rem] lg:tw-max-w-[44rem] xl:tw-max-w-[52rem]",
  leaderboardGalleryItem:
    "tw-max-w-full sm:tw-max-w-[20rem] lg:tw-max-w-[22rem] xl:tw-max-w-[24rem]",
} as const;
